import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { mobileAppUtil } from "../../util";

var GoBack = function GoBack(props) {
  // const { history, handleClick } = props;
  var history = useHistory();
  var location = useLocation();

  var handleOnClick = function handleOnClick(e) {
    if (typeof props.onClick === "function") {
      props.onClick(e);
    }

    if (mobileAppUtil.isMobileApp()) {
      history.goBack(); // if(mobileAppUtil.isiOS()){
      //   setTimeout(() => {
      //     //iOS reload 
      //     location.reload()
      //   },100)
      // }
    } else {
      var redirectURL = window.localStorage.getItem('PDPCategoryURL') || null;
      window.localStorage.removeItem('PDPCategoryURL');

      if (redirectURL) {
        window.location = redirectURL;
      } else {
        window.history.back();
      }
    }
  };

  return /*#__PURE__*/React.createElement("a", {
    className: "cb-button-secondary",
    onClick: handleOnClick
  }, "Keep Shopping");
};

export default GoBack;